import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register Service Worker for PWA + background push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(reg => {
        console.log('SW registered:', reg.scope);

        // Register periodic background sync (check appointments every hour)
        if ('periodicSync' in reg) {
          reg.periodicSync.register('check-appointments', { minInterval: 60 * 60 * 1000 })
            .then(() => console.log('Periodic sync registered'))
            .catch(err => console.warn('Periodic sync not available:', err));
        }
      })
      .catch(err => console.error('SW registration failed:', err));
  });
}
